import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import HeaderDefaultToPage from "../../../components/Common/headerDefaultToPage";
import InputSearch from "../../../components/Inputs/InputSearch";
import { BI_WS0025Context } from "../context";
import { exportGridToCSV, exportGridToExcel, exportGridToHTML } from "../../../components/Utils/export";
import ProgressBar from "../../../components/Common/ProgressBar";

const EXPORT_COLUMNS_AGENDAMENTO = [
  {
    field: "Tipo_Documento",
    header: "Tipo Documento",
    Export: true
  },
  {
    field: "Numero_Documento",
    header: "Nº Documento",
    Export: true
  },
  {
    field: "Peso_Bruto",
    header: "Peso Bruto (kg)",
    align: "right",
    Export: true
  },
  {
    field: "Volume",
    header: "Volume",
    Export: true
  },
  {
    field: "Valor",
    header: "Valor (R$)",
    align: "right",
    Export: true
  },
];

const EXPORT_COLUMNS_PRE_AGENDAMENTO = [
  {
    field: "Numero_Pedido",
    header: "Número Pedido",
    sort: true,
    Export: true
  },
  {
    field: "Numero_Item",
    header: "Número Item",
    Export: true
  },
  {
    field: "Peso_Bruto",
    header: "P.B. (kg)",
    align: "right",
    Export: true
  },
  {
    field: "Quantidade",
    header: "Quantidade",
    align: "right",
    Export: true
  },
  {
    field: "Valor",
    header: "Valor (R$)",
    align: "right",
    Export: true
  },
];

function GridHeader() {
  const { screenConfig, filteredData } = useContext(
    BI_WS0025Context,
  );

  const isPreAgendamento = screenConfig?.Tipo_Tela === "PRE_AGENDAMENTO";

  const columnsList = isPreAgendamento
    ? EXPORT_COLUMNS_PRE_AGENDAMENTO
    : EXPORT_COLUMNS_AGENDAMENTO;

  const { isModalPage, isIframePage } = useSelector(
    (state) => ({
      isModalPage: state.Layout.isModalPage,
      isIframePage: state.Layout.isIframePage,
    }),
  );
  const [btnActionExport, setBtnActionExport] = useState(false);
  const [isExporting, setIsExporting] = useState(false)
  const [exportProgress, setExportProgress] = useState(0)
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [progressMessage, setProgressMessage] = useState('')

    const handleExport = async (item) => {
      try {
        setIsExporting(true)
        setShowProgressBar(true)
        setExportProgress(0)
  
        const icone = item?.icone || ''
        const label = (item?.label || '').toLowerCase()
        const transactionCode = "DF_OT0025"
  
        const options = {
          transactionCode,
          appliedFilters: [],
          filteredData: filteredData?.dataTable,
          flowData: filteredData?.flowData,
          contextData: filteredData?.contextData,
          contextColapseData: filteredData?.contextColapseData,
          enableContextColapseQRCode: filteredData?.enableContextColapseQRCode,
          title: filteredData?.title,
          tableTitle: filteredData?.tableTitle,
          columns: columnsList
        }
  
        setExportProgress(5)
        await new Promise(resolve => setTimeout(resolve, 100))
  
        if (icone.includes('fa-file-pdf') || label.includes('pdf')) {
          setExportProgress(30)
          setProgressMessage('Gerando PDF...')
          await new Promise(resolve => setTimeout(resolve, 200))
          await exportGridToHTML({ ...options, filename: 'relatorio.pdf' })
          setExportProgress(90)
          setProgressMessage('Concluído!')
          await new Promise(resolve => setTimeout(resolve, 200))
        } else if (icone.includes('fa-file-excel') || label.includes('excel') || label.includes('xlsx')) {
          setExportProgress(30)
          await new Promise(resolve => setTimeout(resolve, 200))
          exportGridToExcel({ ...options, filename: 'relatorio.xlsx' })
          setExportProgress(90)
          await new Promise(resolve => setTimeout(resolve, 200))
        } else if (icone.includes('fa-file-csv') || label.includes('csv')) {
          setExportProgress(30)
          await new Promise(resolve => setTimeout(resolve, 200))
          exportGridToCSV({ ...options, filename: 'relatorio.csv' })
          setExportProgress(90)
          await new Promise(resolve => setTimeout(resolve, 200))
        } else if (icone.includes('fa-file-code') || label.includes('html')) {
          setExportProgress(30)
          setProgressMessage('Gerando HTML...')
          await new Promise(resolve => setTimeout(resolve, 200))
          await exportGridToHTML({ ...options, filename: 'relatorio.html', convertToPdf: false })
          setExportProgress(90)
          setProgressMessage('Concluído!')
          await new Promise(resolve => setTimeout(resolve, 200))
        }
  
        setExportProgress(100)
      } catch (error) {
        console.error('Erro na exportação:', error)
      } finally {
        setIsExporting(false)
        setBtnActionExport(false)
        setShowProgressBar(false)
        setExportProgress(0)
        setProgressMessage('')
      }
    }

  if (isModalPage) return null;
  return (
    <Row className="mb-3">
      <Col
        lg={12}
        className="d-flex align-items-center justify-content-between"
      >
        <HeaderDefaultToPage
          goBack={!isIframePage}
          title={`Protocolo de Agendamento: ${screenConfig?.Protocolo || ""
            }`}
        />

        <div className="d-flex justify-content-end gap-3 align-items-center">
          <Button
            onClick={() => window.location.reload()}
            className="bg-transparent border-0 p-0 m-0"
          >
            <i className="fa-solid font-size-24 fa-rotate-right text-primary-dark no-print"></i>
          </Button>

          <Button
            onClick={() => window.print()}
            className="bg-transparent border-0 p-0 m-0 no-print"
          >
            <i className="fas font-size-24 fa-print text-primary-dark"></i>
          </Button>

          <Dropdown
                isOpen={btnActionExport}
                toggle={() => setBtnActionExport(!btnActionExport)}
                className="dropdown-export-dynamic w-auto no-print"
              >
                <DropdownToggle
                  className="bg-transparent border-0 p-0 m-0"
                  caret
                  disabled={isExporting}
                >
                  {isExporting ? (
                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                  ) : (
                    <i className="fas font-size-24 fa-save text-primary-dark"></i>
                  )}
                </DropdownToggle>
                <DropdownMenu transition={{ timeout: 300 }}>
                  <DropdownItem
                    onClick={() => handleExport({ icone: 'fa-solid fa-file-pdf', label: 'pdf' })}
                    className="d-flex align-items-center gap-3"
                  >
                    <i className={'fa-solid fa-file-pdf'}></i>
                    <span>PDF</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleExport({ icone: 'fa-solid fa-file-xls', label: 'excel' })}
                    className="d-flex align-items-center gap-3"
                  >
                    <i className={'fa-solid fa-file-xls'}></i>
                    <span>XLS</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleExport({ icone: 'fa-solid fa-file-csv', label: 'csv' })}
                    className="d-flex align-items-center gap-3"
                  >
                    <i className={'fa-solid fa-file-csv'}></i>
                    <span>CSV</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleExport({ icone: 'fa-solid fa-file-code', label: 'html' })}
                    className="d-flex align-items-center gap-3"
                  >
                    <i className={'fa-solid fa-file-code'}></i>
                    <span>HTML</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>

          <form onSubmit={(e) => e.preventDefault()}>
            <InputSearch
              placeholder="Busca rápida"
              onChange={(e) => console.log("Busca:", e)}
            />
          </form>
        </div>

        <ProgressBar
                    progress={exportProgress}
                    message={progressMessage || 'Gerando relatório...'}
                    isVisible={showProgressBar}
                    showPercentage={true}
                    autoHide={true}
                    className="export-progress-bar"
                  />
      </Col>
    </Row>
  );
}

export default GridHeader;